
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/earn-redeem",
      function () {
        return require("private-next-pages/earn-redeem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/earn-redeem"])
      });
    }
  